<ng-template #uploadpo let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title"><b>Purchase Order Uploader</b></h4>
		<h6 *ngIf="poReviewReady">File count : ({{files.length}})</h6>
		<button mat-stroked-button class="pomodalbtn position-absolute r-70" (click)="$event.preventDefault();toggleUploadHelp()" (keydown.enter)="$event.preventDefault();">Help</button>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>

	</div>
	<div class="modal-body pomodalbody po-upload-modal-body">
		<ng-container *ngIf="!poHelp">
			<p class="text-muted small mb-2" *ngIf="!poReviewReady">One CSV or Excel file. Choose the sheet if the workbook has several tabs, set <strong>Header row #</strong> if titles are not on row 1, load rows, map columns, then match to inventory.</p>
			<ngx-dropzone
				(change)="onPoDropzoneChange($event)"
				class="dropzone"
				*ngIf="!processing_recs && !poReviewReady"
				[multiple]="false"
				[expandable]="true"
				accept=".csv,.xlsx,.xls,text/csv,text/plain,application/csv,text/x-csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				[disabled]="processing_recs">
				<ngx-dropzone-label class="dropzone-label">Drop file, or click to upload</ngx-dropzone-label>
				<ngx-dropzone-preview *ngFor="let f of files;" [removable]="true" (removed)="onRemove(f)">
					<ngx-dropzone-label class="overflow-auto ">{{ f.name }}</ngx-dropzone-label>
				</ngx-dropzone-preview>
			</ngx-dropzone>
			<div *ngIf="poShowParseOptions && poActiveFile && !poReviewReady && !processing_recs" class="border rounded p-3 mb-3 bg-light">
				<h6 class="small font-weight-bold text-uppercase text-muted mb-2">Sheet &amp; header</h6>
				<p class="small text-muted mb-2" *ngIf="poUploadReady">Changing the sheet or header row and loading again replaces the column mapping below.</p>
				<div class="row">
					<div class="col-md-6 mb-3" *ngIf="poSheetNames.length">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Worksheet</mat-label>
							<mat-select [(value)]="poSelectedSheetName">
								<mat-option *ngFor="let s of poSheetNames" [value]="s">{{ s }}</mat-option>
							</mat-select>
							<mat-hint>This file has {{ poSheetNames.length }} sheet(s)</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-6 mb-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Header row #</mat-label>
							<input matInput type="number" min="1" [(ngModel)]="poHeaderRowNumber" name="poHdrRowBeautyWqoh" />
							<mat-hint>Row that contains column titles (e.g. 2 if row 1 is a title only)</mat-hint>
						</mat-form-field>
					</div>
				</div>
				<button mat-raised-button color="primary" type="button" (click)="parsePoSpreadsheetForPoModal()">
					<mat-icon class="align-middle">table_view</mat-icon>
					Load rows &amp; map columns
				</button>
			</div>
			<div class="table-responsive po-upload-map-wrap mb-3" *ngIf="poUploadReady && poUploadedRawData.length && !poReviewReady && !processing_recs">
				<p class="small text-muted mb-2">Map <strong>Internal stock ID</strong> <em>or</em> <strong>Manufacturer part #</strong> (add <strong>Brand</strong> if the sheet splits them). Do not map both ID types. Currency symbols and commas in prices are accepted.</p>
				<div *ngIf="poItemMappingBanner as banner" class="small mb-2" [class.text-warning]="banner.type === 'error'" [class.text-muted]="banner.type === 'hint'">{{ banner.text }}</div>
				<table class="table table-sm table-striped">
					<thead>
						<tr>
							<th *ngFor="let h of poUploadedHeaders" class="small align-top">
								<div class="text-muted text-truncate mb-1" [attr.title]="h">{{ h }}</div>
								<mat-form-field appearance="outline" class="w-100 po-upload-map-field">
									<mat-select [(value)]="poColumnMappings[h]" (selectionChange)="poColumnMappings[h] = $event.value">
										<mat-option *ngFor="let type of poAvailableFieldTypes" [value]="type">{{ poUploadFieldLabel(type) }}</mat-option>
									</mat-select>
								</mat-form-field>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of poUploadedRawData; let i = index" [class.table-primary]="i < 3">
							<td *ngFor="let h of poUploadedHeaders">{{ row[h] }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="table table-responsive text-center" *ngIf="processing_recs && !poReviewReady">
				<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div>
			<mat-tab-group *ngIf="poReviewReady">
				<mat-tab label="Recognized" *ngIf="poDataSource['good']">
					<table mat-table [dataSource]="poDataSource['good']" class="mat-elevation-z8 demo-table" *ngIf="poReviewReady" class="po-table">
						<ng-container matColumnDef="stockid">
							<th mat-header-cell *matHeaderCellDef> Stock ID </th>
							<td mat-cell *matCellDef="let element"> {{element.stockid}} </td>
						</ng-container>

						<ng-container matColumnDef="vendor">
							<th mat-header-cell *matHeaderCellDef> Recommendation Source </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.vendor}} </td>
						</ng-container>

						<ng-container matColumnDef="description">
							<th mat-header-cell *matHeaderCellDef> Description </th>
							<td mat-cell *matCellDef="let element"> {{element.description}} </td>
						</ng-container>

						<ng-container matColumnDef="manufacturer">
							<th mat-header-cell *matHeaderCellDef> MFG </th>
							<td mat-cell *matCellDef="let element"> {{element.manufacturer}} </td>
						</ng-container>

						<ng-container matColumnDef="line">
							<th mat-header-cell *matHeaderCellDef> Line </th>
							<td mat-cell *matCellDef="let element"> {{element.line}} </td>
						</ng-container>

						<ng-container matColumnDef="min">
							<th mat-header-cell *matHeaderCellDef> Min </th>
							<td mat-cell *matCellDef="let element"> {{element.min}} </td>
						</ng-container>

						<ng-container matColumnDef="max">
							<th mat-header-cell *matHeaderCellDef> Max </th>
							<td mat-cell *matCellDef="let element"> {{element.max}} </td>
						</ng-container>

						<ng-container matColumnDef="qty">
							<th mat-header-cell *matHeaderCellDef> Order Quantity </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.quantity}} </td>
						</ng-container>

						<ng-container matColumnDef="price">
							<th mat-header-cell *matHeaderCellDef> Price </th>
							<td mat-cell *matCellDef="let element"> {{element.price | currency}} </td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="poUploadColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: poUploadColumns;"></tr>
					</table>
				</mat-tab>
				<mat-tab label="Unrecognized" *ngIf="poDataSource['bad']">
					<table mat-table [dataSource]="poDataSource['bad']" class="mat-elevation-z8 demo-table" *ngIf="poReviewReady" class="po-table">
						<ng-container matColumnDef="stockid">
							<th mat-header-cell *matHeaderCellDef> Stock ID </th>
							<td mat-cell *matCellDef="let element"> {{element.stockid}} </td>
						</ng-container>

						<ng-container matColumnDef="vendor">
							<th mat-header-cell *matHeaderCellDef> Reccomendation Source </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.vendor}} </td>
						</ng-container>

						<ng-container matColumnDef="description">
							<th mat-header-cell *matHeaderCellDef> Description </th>
							<td mat-cell *matCellDef="let element"> {{element.description}} </td>
						</ng-container>

						<ng-container matColumnDef="manufacturer">
							<th mat-header-cell *matHeaderCellDef> MFG </th>
							<td mat-cell *matCellDef="let element"> {{element.manufacturer}} </td>
						</ng-container>

						<ng-container matColumnDef="line">
							<th mat-header-cell *matHeaderCellDef> Line </th>
							<td mat-cell *matCellDef="let element"> {{element.line}} </td>
						</ng-container>

						<ng-container matColumnDef="min">
							<th mat-header-cell *matHeaderCellDef> Min </th>
							<td mat-cell *matCellDef="let element"> {{element.min}} </td>
						</ng-container>

						<ng-container matColumnDef="max">
							<th mat-header-cell *matHeaderCellDef> Max </th>
							<td mat-cell *matCellDef="let element"> {{element.max}} </td>
						</ng-container>

						<ng-container matColumnDef="qty">
							<th mat-header-cell *matHeaderCellDef> Order Quantity </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.quantity}} </td>
						</ng-container>

						<ng-container matColumnDef="price">
							<th mat-header-cell *matHeaderCellDef> Price </th>
							<td mat-cell *matCellDef="let element"> {{element.price | currency}} </td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="poUploadColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: poUploadColumns;"></tr>
					</table>
				</mat-tab>
			</mat-tab-group>
		</ng-container>
		<ng-container *ngIf="poHelp">
			<div class="row">
				<div class="col">
					<h4><b>Columns</b></h4>
					<p class="small">After loading, map <strong>Internal stock ID</strong> <em>or</em> <strong>Manufacturer part #</strong>, plus <strong>Order quantity</strong>. If there is no internal item code column, map <strong>Brand</strong> and <strong>Manufacturer part #</strong>. Optional: price, description, vendor.</p>
					<hr>
					<h4><b>Notes</b></h4>
					<ul style="max-height: 150px;" class="overflow-auto ">
						<li>
							<p>Each line is validated in inventory. Matches appear under Recognized; unknown item values appear under Unrecognized.</p>
						</li>
						<li>
							<p>Only recognized lines are added when you build the PO.</p>
						</li>
						<li>
							<p>One spreadsheet file per upload. Use a workbook tab that contains the PO lines.</p>
						</li>
						<li>
							<p>When price is left blank, the system uses last PO price, or primary supplier price if needed.</p>
						</li>
						<li>
							<p>Lines with order quantity 0 are skipped.</p>
						</li>
						<li>
							<p>Remove the file from the drop zone to start over.</p>
						</li>
					</ul>
				</div>
				<mat-divider vertical="true"></mat-divider>
				<div class="col">
					<h4><b>Row data tips</b></h4>
					<ul>
						<li>Matching mode is determined by your column mapping (internal ID vs manufacturer part ± brand), not a separate toggle.</li>
						<li>Quantities must be numeric. Prices may include currency symbols; commas are stripped.</li>
					</ul>
					<hr>
					<h4>How matching is chosen</h4>
					<ul>
						<li><strong>Internal stock ID</strong> — your system SKU; sent as-is.</li>
						<li><strong>Manufacturer part #</strong> — resolved to a stockid. With <strong>Brand</strong> mapped, each row needs both; they are combined for lookup.</li>
					</ul>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="modal-footer pomodalfooter po-upload-modal-footer" [ngClass]="upload_error ? 'p-5' : ''">
		<div class="pomodalvendors d-flex flex-wrap w-100 align-items-start mx-0">
			<div>
				<span>Selected Vendor</span>
				<hr class="p-0 m-0">
				<h4><b><span [ngClass]="vendors_detected != false && customer.supplierid != vendors_detected ? 'warning' : ''">{{customer.supplierid}}</span> : {{customer.suppname}}</b></h4>
			</div>
			<div *ngIf="vendors_detected">
				<span>Detected</span>
				<hr class="p-0 m-0">
				<h4><span [ngClass]="customer.supplierid != vendors_detected ? 'warning' : ''">{{vendors_detected}}</span></h4>
			</div>
			<div *ngIf="poReviewReady">
				<span>Recognized</span>
				<hr class="p-0 m-0">
				<h4>Units: {{uploadPodata['units']['good']}} Lines: {{uploadPodata['lines']['good']}} <br></h4>
			</div>
			<div *ngIf="poReviewReady && poDataSource['bad']">
				<span>Unrecognized</span>
				<hr class="p-0 m-0">
				<h4>Units: {{uploadPodata['units']['bad']}} Lines: {{uploadPodata['lines']['bad']}} <br></h4>
			</div>
			<div *ngIf="upload_error" class="error_container">
				<span>Processing Error</span>
				<hr class="p-0 m-0 w-100 ">
				<h4 class='d-flex '>
					<ng-container *ngFor="let file of upload_error">
						<div *ngFor="let err of file | keyvalue" class="mr-5">
							{{err.key}} : <span class="warning" style="font-size: 16px;">{{err.value.message}} &nbsp;</span>
							<br style="height: 1px;">
							<span style="font-size: 12px;">{{err.value.file}}</span>
						</div>
					</ng-container>
				</h4>
			</div>
		</div>

		<div class="po-upload-footer-actions" [class.po-upload-footer-review]="poReviewReady">
			<button mat-stroked-button *ngIf="!poReviewReady" class="pomodalbtn" (click)="$event.preventDefault();uploadPo()" (keydown.enter)="$event.preventDefault();" [disabled]="!poUploadReady || !files.length">Match to inventory</button>
			<button mat-stroked-button *ngIf="poReviewReady" class="pomodalbtn" (click)="$event.preventDefault();resetPoReviewResults()" (keydown.enter)="$event.preventDefault();">Back</button>
			<button mat-stroked-button *ngIf="poReviewReady" class="pomodalbtn" (click)="$event.preventDefault();buildPO()" (keydown.enter)="$event.preventDefault();" [disabled]="!poDataSource['good']">Build PO</button>
		</div>
	</div>
</ng-template>
<ng-template #mmmodal let-modal>
	<div class="modal-header mm-modal-header" [class.mm-modal-header--complete]="promo && isPromoMixMatchComplete(promo)">
		<div class="mm-header-info">
			<span class="mm-header-stockid">{{ promo.itemdesc.stockid }}</span>
			<span class="mm-header-desc">{{promo.itemdesc.description }}</span>
		</div>
		<div class="mm-header-trail">
			<div class="mm-header-complete" *ngIf="promo && isPromoMixMatchComplete(promo)">
				<mat-icon class="mm-header-complete__icon">check_circle</mat-icon>
				<span class="mm-header-complete__text">Complete — ready to add</span>
			</div>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
	</div>
	<div class="modal-body mm-modal-body text-dark d-flex p-0" [class.mm-modal-body--substituting]="showSubstitution">
		<div class="mm-main-content">

			<div class="mm-top-bar">
				<div class="mm-top-intros">
					<ng-container *ngFor="let intro of promo.intros">
						<ng-container *ngIf="intro.type === '1' || intro.type === 1">
							<span class="mm-intro-pill">{{ intro.stockid }} — {{ intro.description }} ({{ intro.qty }} @ {{ intro.price | currency }})</span>
						</ng-container>
					</ng-container>
				</div>
				<div class="mm-top-controls">
					<mat-form-field appearance="outline" class="mm-qty-field">
						<mat-label>Qty</mat-label>
						<span matPrefix>#</span>
						<input matInput type="number" [(ngModel)]="promo.qty" (input)="setParent($event, promo)" class="text-right">
					</mat-form-field>
					<button class="btn btn-primary mm-add-btn" [disabled]="isCompleted(promo)" (click)="addMM(promo)">
						ADD TO ORDER
					</button>
				</div>
			</div>

			<div class="mm-scan-bar">
				<div class="mm-input-wrap">
					<mat-icon class="mm-input-icon">qr_code_scanner</mat-icon>
					<input class="mm-input" placeholder="Scan to select..." (keyup.enter)="searchPromos($event)">
				</div>
			</div>

			<div class="mm-groups-scroll" *ngIf="promo">
				<ng-container *ngFor="let intro of promo.intros">
					<div class="mm-group" *ngIf="intro.type != '1'">
						<div class="mm-group-header">
							<div class="mm-group-title">
								<b>{{ intro.name }} {{ intro.description }}</b>
							</div>
							<div class="mm-group-progress" [ngClass]="{'mm-group-progress--done': isIntroMixMatchSatisfied(intro), 'mm-group-progress--error': intro.error}">
								<span [ngClass]="{'zero-quantity': getMMQtyUsed(intro) == 0}">{{ intro.dsptype }} {{ getMMQtyUsed(intro) | number }} / {{ intro.floor }}</span>
							</div>
						</div>

					<div class="mm-search-bar">
						<div class="mm-input-wrap">
							<mat-icon class="mm-input-icon">search</mat-icon>
							<input class="mm-input" tabindex="1" placeholder="Search Mix &amp; Match..." [(ngModel)]="intro.searchQuery" (input)="filterItems(intro)" appCollapseKeyboard>
							<button class="mm-input-clear" *ngIf="intro.searchQuery" tabindex="-1" (click)="intro.searchQuery = ''; filterItems(intro)">
								<mat-icon>close</mat-icon>
							</button>
						</div>
					</div>

						<div class="mm-item-list">
							<ng-container *ngFor="let item of (intro.filteredItems ? intro.filteredItems : intro.items)">
								<div class="mm-item-row" [ngClass]="item.quantity > 0 ? 'mm-item-row--picked' : ''">
									<div class="mm-item-info">
										<span class="mm-item-stockid">{{ item.stockid }}</span>
										<span *ngIf="config.env.client !== 'aaprod'" class="mm-qoh-badge">{{ item.qoh.quantity }} <small>qoh</small></span>
										<span class="mm-item-desc">{{ item.description }}</span>
									</div>
									<div class="mm-item-qty">
										<button mat-icon-button class="mm-qty-btn" (click)="decrementmm(item, intro)">
											<mat-icon>remove</mat-icon>
										</button>
										<input type="text" class="mm-qty-input" [value]="item.quantity | number" (input)="qtyMM($event, item, intro)">
										<button mat-icon-button class="mm-qty-btn" (click)="incrementmm(item, intro)">
											<mat-icon>add</mat-icon>
										</button>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</div>

		</div><!-- /.mm-main-content -->
		<div class="mm-sidepanel" *ngIf="mmSidePanel" [class.mm-sidepanel--substituting]="showSubstitution">
			<div class="mm-sidepanel-tools w-100" *ngIf="allow_mm_substitutes">
				<button class="w-100 sub-btn" mat-stroked-button color="primary" (click)="showSubstitution = !showSubstitution">
					<ng-container *ngIf="!showSubstitution">Substitute Item?</ng-container>
					<ng-container *ngIf="showSubstitution">Substituting...</ng-container>
				</button>
			</div>
			<div class="substituion-block" *ngIf="showSubstitution">
				<h5 class="mm-sub-section-title">Substitute with
					<mat-icon *ngIf="substituteItem" class="mm-sub-section-title__icon text-success">check_circle</mat-icon>
				</h5>
				<mat-form-field class="mm-sub-search-field w-100" appearance="outline" *ngIf="!substituteItem">
					<input placeholder="Scan barcode or enter SKU" matInput type="text" [formControl]="mmSubstituteRef">
					<svg *ngIf="subsearch" class="spinner subsearch" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</mat-form-field>
				<div *ngIf="substituteItemList.length && !substituteItem" class="mm-sub-pick-scroll">
					<div class="mm-sub-pick-list" role="list">
						<div *ngFor="let item of substituteItemList" class="mm-sub-pick-row" role="listitem">
							<div class="mm-sub-pick-info">
								<span class="mm-sub-pick-sku">{{ item.stockid }}</span>
								<span class="mm-sub-pick-desc">{{ item.description }}</span>
							</div>
							<button type="button" mat-stroked-button color="primary" class="mm-sub-pick-btn" (click)="substituteItem = item">Select</button>
						</div>
					</div>
				</div>
				<div class="mm-sub-picked-card" *ngIf="substituteItem">
					<div class="mm-sub-picked-card__head">
						<b class="mm-sub-picked-card__sku">{{ substituteItem.stockid }}</b>
						<button type="button" mat-icon-button class="text-danger mm-sub-picked-card__remove" (click)="substituteItem = false" aria-label="Clear selection">
							<mat-icon>close</mat-icon>
						</button>
					</div>
					<div class="mm-sub-picked-card__desc">{{ substituteItem.description }}</div>
				</div>
				<h5 class="mm-sub-section-title">Apply to group
					<mat-icon *ngIf="mmSubstituteGroupRef.value" class="mm-sub-section-title__icon text-success">check_circle</mat-icon>
				</h5>
				<mat-button-toggle-group class="m-auto mb-1 d-flex intro-sub-select" name="Intro" aria-label="Intro Selector" [formControl]="mmSubstituteGroupRef">
					<ng-container *ngFor="let int of promo.intros">
						<mat-button-toggle *ngIf="int.mmid" value="{{int.name}}">{{int.name}}</mat-button-toggle>
					</ng-container>
				</mat-button-toggle-group>
				<button mat-raised-button color="accent" (click)="getSub(mmSubstituteGroupRef.value)" class="w-100 mt-1" [disabled]="!mmSubstituteGroupRef.value || !substituteItem">
					Add Substitution
				</button>
			</div>
			<div class="selected-panel">
				<div class="mm-selected-scroll">
					<ng-container *ngFor="let item of mm_items_selected">
						<div *ngIf="item.quantity > 0" class="mm-selected-row" [class.mm-selected-row--dim]="showSubstitution" [class.mm-selected-row--sub]="item.substitute">
							<div class="mm-selected-top">
								<span class="mm-selected-stockid">{{ item.stockid }}</span>
								<div class="mm-selected-qty-controls">
									<button type="button" mat-icon-button class="mm-qty-btn" (click)="setter(item, item.quantity - 1)">
										<mat-icon>remove</mat-icon>
									</button>
									<input type="text" class="mm-qty-input" [value]="item.quantity" (change)="setter(item, +$event.target.value || 0)">
									<button type="button" mat-icon-button class="mm-qty-btn" (click)="setter(item, 1, true)">
										<mat-icon>add</mat-icon>
									</button>
								</div>
							</div>
							<div class="mm-selected-desc">{{ item.description }}</div>
							<div class="mm-selected-actions">
								<button type="button" mat-stroked-button color="warn" class="mm-selected-action mm-selected-action--remove" (click)="setter(item, 0)">Remove</button>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div><!-- /.mm-sidepanel -->
	</div><!-- /.modal-body -->
</ng-template>
<ng-template #edumodal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ event.name }} Registration - {{ event.location_name }} - {{event.date}}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				{{ event.short_description }}
			</div>
		</div>
		<br>
		<div class="row">
			<div class="col-3">
				<b>Host</b>
			</div>
			<div class="col-3">
				{{ event.host }}
			</div>
			<div class="col-3">
				<b>Presenter</b>
			</div>
			<div class="col-3">
				{{ event.artist_name }}
			</div>
		</div>
		<hr>
		<div class="row">
			<div class="col-3">
				<b>Cost Per Seat</b>
			</div>
			<div class="col-3">
				{{ event.discount | currency }}
			</div>
			<div class="col-3">
				<b>Capacity Remaining</b>
			</div>
			<div class="col-3">
				{{ event.remaining }} / {{ event.uses_total }}
			</div>
		</div>
		<hr>
		<form [formGroup]="regForm">
			<div class="row">

				<div class="col-2">
					<mat-form-field>
						<mat-label>Name</mat-label>
						<input matInput type="text" formControlName="eduname">
					</mat-form-field>
				</div>
				<div class="col-2">
					<mat-form-field>
						<mat-label>Cell Phone</mat-label>
						<input matInput type="text" formControlName="educell">
					</mat-form-field>
				</div>
				<div class="col-2">
					<mat-form-field>
						<mat-label>Email</mat-label>
						<input matInput type="text" formControlName="eduemail">
					</mat-form-field>
				</div>
				<div class="col-2">
					<mat-form-field>
						<mat-label>Instagram</mat-label>
						<input matInput type="text" formControlName="eduinsta">
					</mat-form-field>
				</div>
				<div class="col-2">
					<button type="button" mat-stroked-button aria-label="Add" (click)="addSeat(event)" [disabled]="!regForm.valid">
						<mat-icon>add</mat-icon> Add Seat
					</button>
				</div>

			</div>
		</form>
		<div class="row">
		<div class="col-12">
					<mat-form-field>
						<mat-label>Notes</mat-label>
						<input matInput type="text" [formControl]="edunotes">
					</mat-form-field>
		</div>
		</div>
		<hr>
		<div class="row" *ngFor="let seat of event.seats">
			<div class="col-2">
				{{ seat.name }}
			</div>
			<div class="col-2">
				{{ seat.cell }}
			</div>
			<div class="col-2">
				{{ seat.email }}
			</div>
			<div class="col-2">
				{{ seat.insta }}
			</div>
			<div class="col-2">
				<button type="button" mat-stroked-button aria-label="Add" (click)="remSeat(seat)">
					<mat-icon>remove</mat-icon>
				</button>
			</div>
		</div>
		<span *ngIf="loyaltylist.length"><h3> Loyalty Programs </h3></span>
		<form [formGroup]="eduReward">
		<div class="row" *ngFor="let r of loyaltylist">
			<div class="col-4">
				{{r.name}}
			</div>
			<div class="col-4">
				<mat-form-field *ngIf="r.type == 2">
					<mat-label>{{r.text}}</mat-label>
					<input matInput formControlName="additional-{{r.id}}" />
				</mat-form-field>
			</div>
			<div class="col-4">
				<mat-form-field>
					<mat-label>$ Amount</mat-label>
					<input matInput formControlName="amount-{{r.id}}" />
				</mat-form-field>
			</div>

		</div>
		</form>
	</div>
	<div class="modal-footer">
		<h4 class="modal-title">Total: {{ event.total | currency}}</h4>
		<button type="button" mat-stroked-button aria-label="Add" (click)="addedureg(event)" [disabled]="!event.seats.length">
			<mat-icon>add</mat-icon> Add To Order
		</button>
	</div>
</ng-template>
<ng-template #itemHistoryRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ selecteditem.stockid }} <span [innerHTML]="cleanAndFormatHTML(selecteditem.description)"></span></h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<mat-tab-group>
			<mat-tab label="{{ customer.name }} Sales">
				<div class="row mt-3">
					<div class="col-12">

						<div class="row" *ngIf="!itemhistory.length">
							<div class="col-12 text-center">
								<h5>No Sales History</h5>
							</div>
						</div>
						<table class="table table-sm smaller-font" *ngIf="itemhistory.length">
							<tr>
								<th>Date</th>
								<th>Type</th>
								<th>Order#</th>
								<th>Qty</th>
								<th>Price</th>
								<th>Total</th>
							</tr>
							<tr *ngFor="let i of itemhistory">
								<td>{{ i.trandate }}</td>
								<td>{{ i.typename }}</td>
								<td>{{ i.order_ }}</td>
								<td>{{ i.quantity }}</td>
								<td>{{ i.price  | currency}}</td>
								<td>{{ i.price * i.quantity | currency }}</td>
							</tr>
						</table>
					</div>
				</div>
			</mat-tab>
			<mat-tab label="Purchases">
				<!-- (orderloaded)="selectItemLookup($event)" (orderinvoice)="invoiceOrder($event)" -->
				<h4>Open Purchase Orders</h4>
				<app-open-purchase-orders [item]="selecteditem.stockid"></app-open-purchase-orders>
				<mat-divider></mat-divider>
				<h4>Purchase History</h4>
				<table class="table table-sm" *ngIf="itemhistory.purchase">
					<thead>
						<tr>
							<th class="text-left w-20">SUPP</th>
							<th class="text-left w-20">PO</th>
							<th class="text-left w-20">DATE</th>
							<th class="text-center w-20">QTY</th>
							<th class="text-right w-20">COST</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let h of itemhistory.purchase">
							<td class="text-left"> {{h.suppname}}</td>
							<td class="text-left"> {{h.orderno}}</td>
							<td class="text-left"> {{h.orddate}}</td>
							<td class="text-center"> {{h.quantityord}}</td>
							<td class="text-right"> {{h.unitprice | currency}}</td>
						</tr>
					</tbody>
				</table>
			</mat-tab>
			<mat-tab label="Purchase Data">
				<div class="row m-0 p-0 mt-3">
					<ng-container *ngFor="let pdata of selecteditem.purchdata">
						<mat-card class="ml-auto mr-auto col-md-4 cpdata" [ngClass]="selecteditem.selected_po_option == pdata ? 'cpdata-selected': '' " (click)="setItemSelectedPoOption(selecteditem,pdata)">
							<mat-card-header>
								<mat-card-subtitle><span matBadge="{{ pdata.preferred_sort }}" matBadgeSize="small" matBadgeColor="accent"></span></mat-card-subtitle>
								<mat-card-title>{{ pdata.supplierid }} - {{ pdata.suppname }} </mat-card-title>
								<mat-card-title> {{ pdata.price | currency }}</mat-card-title>
							</mat-card-header>
							<mat-card-content>
								<h4>Inventory</h4>
								<ng-container *ngIf="pdata.remote">
									<ul class="entry-list p-0 m-0" *ngFor="let remote of pdata.remote">
										<li>
											<div class="spec-label">{{ remote.feedlabel }}:</div>
											<div class="spec-value">{{ remote.qty }}</div>
										</li>
									</ul>
								</ng-container>
								<ng-container *ngIf="!pdata.remote">
									<ul class="entry-list p-0 m-0">
										<li>
											<div class="spec-label">N/A:</div>
											<div class="spec-value">N/A</div>
										</li>
									</ul>
								</ng-container>
							</mat-card-content>

						</mat-card>
					</ng-container>
				</div>
				<app-purchase-data [item]="selecteditem" (newitemdata)="updateItem($event)"></app-purchase-data>
			</mat-tab>
		</mat-tab-group>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #purchasedetails let-modal (click)="stopProp($event)">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Purchase Information</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row" *ngFor="let item of purchase_items">
			<div class="col-12">
				<app-purchase-data [item]="item" (newitemdata)="updateItem($event)"></app-purchase-data>
			</div>
			<div [ngClass]="item.purchdata.length == 1 ? 'col-md-12': 'col-md-6'" *ngFor="let pdata of item.purchdata">
				<div class="card highlight" (click)="setPurchOrderOptions(item.cart_id, pdata)">
					<span matBadge="{{ pdata.preferred_sort }}" matBadgeSize="large" matBadgeColor="accent"></span>
					<div class="card-header text-center">
						<h4 class="card-title text-center">{{ pdata.supplierid }} - {{ pdata.suppname }} {{ pdata.price | currency }}</h4>
					</div>
					<div class="card-body text-center">
						<div class="col-12">
							<h5>{{ pdata.stockid }} {{ pdata.supplierdescription }}</h5>
						</div>
						<div class="col-12 p-0 m-0">
							<ul class="entry-list p-0 m-0" *ngFor="let remote of pdata.remote">
								<li>
									<div class="spec-label">{{ remote.feedlabel }}:</div>
									<div class="spec-value">{{ remote.qty }}</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #itemdetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title"><b>{{ item_details.stockid }}</b><span [innerHTML]="item_details.name"></span> &nbsp;&nbsp;&nbsp;
			<a [routerLink]="'/inventory/view/'+item_details.stockid"><i class="pointer fa fa-edit"></i></a>
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<mat-card class="tire-card " *ngIf="item_details">
				<mat-card-title-group>
					<mat-card-title>
						<h3 [innerHTML]="cleanAndFormatHTML(item_details.descriptions.name)"></h3>
						<section class="section-small" [innerHTML]="cleanAndFormatHTML(item_details.descriptions.description)"></section>
					</mat-card-title>
					<div class="tire-image">
						<div class="tire-image-container" *ngIf="item_details.image_large">
							<img mat-card-lg-image src="{{ item_details.image_large }}" class="img img-responsive large-thumb" lazy>
						</div>
					</div>
				</mat-card-title-group>
				<mat-card-content class="padding-0">
					<mat-tab-group #tabPanel mat-align-tabs="start" color="accent">
						<mat-tab label="Overview">
							<div class="row">
								<div class="col-md-6">
									Features:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.features)"></span>
								</div>
								<div class="col-md-6">
									Benefits:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.benefits)"></span>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Attributes">
							<div class="row">
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Specs">
							<!-- <mat-form-field appearance="standard" *ngIf="!addingattribute" class="text-right">
								<mat-label>Search Attributes</mat-label>
								<input type="text" class="text-right m-0 p-0" matInput (input)="searchAttributes($event.target.value)" />
							</mat-form-field> -->

							<div class="row">
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #orderdetailsModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">{{ orderdetails.deliverto }} ( {{ orderdetails.debtorno }}.{{orderdetails.branchcode}} ) </h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12">
				<h4>INVOICE: <b>{{ orderdetails.orderno }}</b><br>
				</h4>
			</div>
		</div>

		<div class="table table-responsive">
			<table class="table table-sm">
				<thead>
					<tr>
						<th class="text-left">ITEM</th>
						<th class="text-left">DESC</th>
						<th class="text-center">QTY</th>
						<th class="text-center">PRICE</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of orderdetails.details">
						<td class="text-left"><b>{{ item.stkcode }}</b></td>
						<td>{{ item.itemdesc }}</td>
						<td class="text-center">{{ item.quantity }} </td>

						<td class="text-right">{{ item.unitprice * item.quantity | currency }} </td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div #itemRowsScroll class="item-rows item-rows-scroll-host">
<ng-container *ngFor="let item of filtered_items; let i = index; trackBy: trackByStockId">
  <!-- COMPACT LAYOUT (shown until lg) -->
  <div class="d-lg-none mobile-item-row item-row" [ngClass]="item.quantity > 0 ? 'mobile-item-row--picked' : ''">
	<div class="mobile-item-top">
	  <div class="mobile-item-image" (click)="expand_row(i)">
		<div [ngClass]="isExpanded(i) ? 'pholder_expanded' : 'pholder'">
		  <img src="{{item.image_large}}" class="img img-fluid p-0 m-0" lazy>
		</div>
	  </div>
	  <div class="mobile-item-info" (click)="openModal(itemdetails, item)">
		<span class="bold">{{ item.stockid }}</span>
		<span class="lightbrand">{{ item.brand }}</span>
		<span class="lightdesc">{{ item.description }}</span>
		<div *ngIf="!issalesman && !isdriver" class="mobile-qoh-row">
		  <app-qoh-popover [item]="item">
			<span class="compact-pill qoh-pill" [ngClass]="getQohPillClass(item.locqoh)">QOH {{ item.locqoh }}</span>
		  </app-qoh-popover>
		  <span class="compact-pill avail-pill" [ngClass]="getAvailPillClass(item)">AVAIL {{ item.locqoh - item.qos }}</span>
		</div>
	  </div>
	  <div class="mobile-item-price">
		<div class="form-field">
		  <label>
			<span>Disc %</span>
			<input type="text" tabindex="-1" inputmode="numeric" pattern="[0-9]*" (input)="updateSearchDiscount($event, item)" [value]="item.discount" class="text-right outlined-input mobile-price-input">
		  </label>
		</div>
		<div class="form-field">
		  <label>
			<span *ngIf="type == '21'">Cost $</span>
			<span *ngIf="type != '21'">{{ item.specialflag ? 'Special $' : (item.discount ? 'Net $' : 'Price $') }}</span>
			<input type="text" tabindex="-1" inputmode="numeric" pattern="[0-9]*" (input)="updateSearchPrice($event, item)" [value]="item.discount ? getEffectivePrice(item) : item.price" class="text-right outlined-input mobile-price-input" [ngClass]="item.specialflag ? 'specialbox' : ''">
		  </label>
		  <span *ngIf="item.hasdiscount && item.discount" class="mobile-hint">
			- {{ getDiscountTaken(item) | currency }} ({{ item.discount }}%)
		  </span>
		  <span *ngIf="item.fetvalue && item.fetvalue != '0.00'" class="mobile-hint">
			FET: {{ item.fetvalue | currency }}
		  </span>
		</div>
	  </div>
	</div>
	<div class="mobile-item-bottom">
	  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="decrement(item)">
		<small><i class="material-icons">remove</i></small>
	  </button>
	  <div class="quantity-input-container mobile-qty-input mx-2" #inputElement>
		<label [attr.for]="'qty-row-' + i" [ngClass]="isInputFocused ? 'shrink' : ''">{{ isInputFocused || item.quantity ? '' : '&nbsp;Qty' }}</label>
		<ng-container *ngIf="i === 0">
		  <input #firstItem #firstQtyInput type="text" [attr.id]="'qty-row-' + i" tabindex="{{ i + 2 }}" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="item.quantity" class="text-right" (keydown.enter)="handleEnterInput(item, i, $event)" (keydown.tab)="handleTabKey($event, i)" (focus)="selectText($event)">
		</ng-container>
		<ng-container *ngIf="i !== 0">
		  <input type="text" [attr.id]="'qty-row-' + i" tabindex="{{ i + 2 }}" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="item.quantity" class="text-right" (keydown.enter)="handleEnterInput(item, i, $event)" (keydown.tab)="handleTabKey($event, i)" (focus)="selectText($event)">
		</ng-container>
	  </div>
	  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="increment(item)">
		<small><i class="material-icons">add</i></small>
	  </button>
	  <div [ngClass]="item.quantity > 0 ? 'linetotal_row_picked' : 'linetotal_row'" class="row mobile-total-pill ml-2">
		<span class="linetotal_price text-dark">&nbsp;{{ getLineTotal(item) | currency }}&nbsp;</span>
		<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="addToOrder(item)" *ngIf="!item.ispromo && !item.isevent">
		  <small><i class="material-icons">add_box</i></small>
		</button>
		<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="triggerEdu(item)" *ngIf="item.isevent">
		  <small><i class="material-icons">settings</i></small>
		</button>
		<ng-container *ngIf="item.ispromo">
		  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
			<small><i class="material-icons">settings</i></small>
		  </button>
		  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
			<small><i class="material-icons">add_box</i></small>
		  </button>
		</ng-container>
	  </div>
	</div>
  </div>

  <!-- DESKTOP LAYOUT (shown on lg+) -->
  <div class="d-none d-lg-flex item-card item-row" [ngClass]="item.quantity > 0 ? 'item-card--picked' : ''">
	<div class="item-card__image" (click)="expand_row(i)">
	  <div [ngClass]="isExpanded(i) ? 'pholder_expanded' : 'pholder'">
		<img src="{{item.image_large}}" class="img img-responsive img-fluid p-0 m-0 attribute-image" lazy>
		<span *ngFor="let image of item.attribute_images">
		  <img src="{{image}}" class="img img-responsive img-fluid p-0 m-0 attribute-image" lazy>
		</span>
	  </div>
	</div>
	<div class="item-card__info" (click)="openModal(itemdetails, item)">
	  <button tabindex="-1" mat-icon-button aria-label="Change Vendor" color="accent" (click)="$event.stopPropagation(); viewPurchOrderOptions(item)" *ngIf="config.pofromorder && config.env.package == 'tires'">
		<mat-icon class="smaller-font">edit</mat-icon>
	  </button>
	  <span class="bold pointer">{{ item.stockid }}</span>
	  <span class="lightbrand">{{ item.brand }}</span>
	  <span class="lightdesc">{{ item.description }}</span>
	</div>
	<div class="item-card__inventory" *ngIf="!issalesman && !isdriver">
	  <div class="compact-pills">
		<app-qoh-popover [item]="item">
		  <div class="compact-item pointer compact-item--pill">
			<span class="compact-pill-label">QOH</span>
			<span class="compact-pill qoh-pill" [ngClass]="getQohPillClass(item.locqoh)">{{ item.locqoh }}</span>
		  </div>
		</app-qoh-popover>
		<div class="compact-item compact-item--pill">
		  <span class="compact-pill-label">COMM</span>
		  <span class="compact-pill com-pill">{{ item.qos }}</span>
		</div>
		<div class="compact-item compact-item--pill">
		  <span class="compact-pill-label">AVAIL</span>
		  <span class="compact-pill avail-pill" [ngClass]="getAvailPillClass(item)">{{ item.locqoh - item.qos }}</span>
		</div>
	  </div>
	</div>
	<div class="item-card__pricing">
	  <div class="price-field-wrap">
		<span class="price-field-label">Disc %</span>
		<input type="text" tabindex="-1" inputmode="numeric" pattern="[0-9]*" (input)="updateSearchDiscount($event, item)" [value]="item.discount" class="text-right outlined-input price-field-input">
	  </div>
	  <div class="price-field-wrap">
		<span class="price-field-label">
		  <ng-container *ngIf="type == '21'">Cost $</ng-container>
		  <ng-container *ngIf="type != '21'">{{ item.specialflag ? 'Special $' : 'Sell Price $' }}</ng-container>
		</span>
		<input type="text" tabindex="-1" inputmode="numeric" pattern="[0-9]*" (input)="updateSearchPrice($event, item)" [value]="item.price" class="text-right outlined-input price-field-input" [ngClass]="item.specialflag ? 'specialbox' : ''">
		<div class="price-field-hint">
		  <span *ngIf="item.discount" class="text-danger bolder">
			- {{ getDiscountTaken(item) | currency }} ({{ item.discount }}%)
		  </span>
		  <span *ngIf="item.price_break && !item.discount" class="text-danger bolder">
			{{ item.price_break.quantitybreak }} @ {{ item.price_break.price | currency }}
		  </span>
		  <span *ngIf="item.fetvalue && item.fetvalue != '0.00'" class="text-danger bolder">
			FET: {{ item.fetvalue | currency }}
		  </span>
		</div>
	  </div>
	</div>
	<div class="item-card__quantity">
	  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="decrement(item)">
		<small><i class="material-icons">remove</i></small>
	  </button>
	  <div class="quantity-input-container mx-2" #inputElement>
		<label [attr.for]="'qty-row-' + i" [ngClass]="isInputFocused ? 'shrink' : ''">{{ isInputFocused || item.quantity ? '' : '&nbsp;Qty' }}</label>
		<ng-container *ngIf="i === 0">
		  <input #firstItem #firstQtyInput type="text" [attr.id]="'qty-row-' + i" tabindex="{{ i + 2 }}" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="item.quantity" class="text-right" (keydown.enter)="handleEnterInput(item, i, $event)" (keydown.tab)="handleTabKey($event, i)" (focus)="selectText($event)">
		</ng-container>
		<ng-container *ngIf="i !== 0">
		  <input type="text" [attr.id]="'qty-row-' + i" tabindex="{{ i + 2 }}" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="item.quantity" class="text-right" (keydown.enter)="handleEnterInput(item, i, $event)" (keydown.tab)="handleTabKey($event, i)" (focus)="selectText($event)">
		</ng-container>
	  </div>
	  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="increment(item)">
		<small><i class="material-icons">add</i></small>
	  </button>
	</div>
	<div class="item-card__total">
	  <span class="units" *ngIf="item.purchdata[0].conversionfactor != 1 && item.quantity != 0 && type == 21">
		{{ item.quantity * item.purchdata[0].conversionfactor }} each
	  </span>
	  <div [ngClass]="item.quantity > 0 ? 'linetotal_row_picked' : 'linetotal_row'" class="row flex-grow-1 align-items-center">
		<span class="linetotal_price text-dark">&nbsp;{{ getLineTotal(item) | currency }}&nbsp;</span>
		<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="addToOrder(item)" *ngIf="!item.ispromo && !item.isevent">
		  <small><i class="material-icons">add_box</i></small>
		</button>
		<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="triggerEdu(item)" *ngIf="item.isevent">
		  <small><i class="material-icons">settings</i></small>
		</button>
		<ng-container *ngIf="item.ispromo">
		  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
			<small><i class="material-icons">settings</i></small>
		  </button>
		  <button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm linetotal_button" (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
			<small><i class="material-icons">add_box</i></small>
		  </button>
		</ng-container>
	  </div>
	</div>
  </div>
</ng-container>
</div>
